<script setup lang="ts">
// Material Symbols `real_estate_agent` — a hand holding a house, the design's
// marker for a brokered/managed figure (Figma 20779:5685). PrimeIcons has no
// equivalent; `pi-home` is a bare house and loses the "someone is handling this
// for you" reading.
defineOptions({ inheritAttrs: false })
</script>

<template>
  <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" v-bind="$attrs">
    <path
      d="M19 14V7.5L14 4L9 7.5V9H7V6.5L14 1.5L21 6.5V14H19ZM14.5 8H15.5V7H14.5V8ZM12.5 8H13.5V7H12.5V8ZM14.5 10H15.5V9H14.5V10ZM12.5 10H13.5V9H12.5V10ZM7 18.5L13.95 20.4L19.9 18.55C19.8167 18.4 19.6958 18.2708 19.5375 18.1625C19.3792 18.0542 19.2 18 19 18H13.95C13.5 18 13.1417 17.9833 12.875 17.95C12.6083 17.9167 12.3333 17.85 12.05 17.75L9.725 16.975L10.275 15.025L12.3 15.7C12.5833 15.7833 12.9167 15.85 13.3 15.9C13.6833 15.95 14.25 15.9833 15 16C15 15.8167 14.9458 15.6417 14.8375 15.475C14.7292 15.3083 14.6 15.2 14.45 15.15L8.6 13H7V18.5ZM1 22V11H8.6C8.71667 11 8.83333 11.0125 8.95 11.0375C9.06667 11.0625 9.175 11.0917 9.275 11.125L15.15 13.3C15.7 13.5 16.1458 13.85 16.4875 14.35C16.8292 14.85 17 15.4 17 16H19C19.8333 16 20.5417 16.275 21.125 16.825C21.7083 17.375 22 18.1 22 19V20L14 22.5L7 20.55V22H1ZM3 20H5V13H3V20Z"
    />
  </svg>
</template>
